import {
  SET_USER_STATUS,
  UPDATE_USER_STATUS,
  SET_USER_LOGOUT,
} from 'constants/system';

let initialData = {};
try {
  if (localStorage.getItem('user')) {
    initialData = JSON.parse(localStorage.getItem('user'));
  }
} catch (err) {
  console.error(err);
}

const initialState = {
  ...initialData,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_STATUS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UPDATE_USER_STATUS: {
      let user = JSON.parse(localStorage.getItem('user'));
      localStorage.setItem(
        'user',
        JSON.stringify({ ...user, ...action.payload }),
      );
      return {
        ...state,
        ...action.payload,
      };
    }
    case SET_USER_LOGOUT: {
      return {};
    }
    default:
      return state;
  }
};

export default user;
